import { useEffect } from "react";
import { Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import DocumentTypesTable from "./DocumentTypesTable.jsx";

export default function DocumentTypeSettingsPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "Dokumenttypen", path: "/admin/document-types" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <>
      <Typography variant="h5" mb={2}>
        Dokumenttypen
      </Typography>

      <DocumentTypesTable />
    </>
  );
}
